export default __webpack_public_path__ + "static/media/hinge-instr-1.4b68907a.jpg";